export const LITE = "Lite";
export const BUSINESS = "Biz";
export const PROFESSIONAL = "Pro";

export const DISABLE = 'Disable';
export const SWAP = 'Swap';
export const UPGRADE = 'Upgrade';
export const DOWNGRADE = 'Downgrade';